import { Message } from "@/reducers/messagesSlice"
import MessageReplyTo from "@/components/chat/MessageReplyTo"
import { Button } from "@/components/ui/button"
import { X } from "lucide-react"
import { useMessageData } from "@/components/chat/useMessageData"

type ChatReplyBarProps = {
  replyMessage: Message
  onClearReply: () => void
}

export const ChatReplyBar = ({
  replyMessage,
  onClearReply,
}: ChatReplyBarProps) => {
  const messageData = useMessageData(replyMessage)
  const variantBackgrounds = {
    incoming: "bg-blue-100 dark:bg-blue-950 rounded-bl-none",
    outgoing: "bg-secondary text-accent-foreground rounded-br-none",
    ai: "bg-violet-100 dark:bg-violet-950 rounded-lg",
  }

  const bgColor = messageData.fromSlickAI
    ? variantBackgrounds["ai"]
    : !(messageData.isIncoming && messageData.isFromDriver)
      ? variantBackgrounds["outgoing"]
      : variantBackgrounds["incoming"]
  return (
    <div
      className={`relative flex w-full items-center gap-2 rounded-md before:absolute before:left-0 before:top-0 before:h-full before:w-[3px] before:rounded-l-md before:bg-active-chat ${bgColor}`}
    >
      <div className="max-h-16 flex-1 overflow-hidden px-0 [&>div>div]:min-w-full [&>div>div]:rounded-none [&>div]:ml-1 [&>div]:mr-[0px] [&>div]:w-full [&>div]:flex-row">
        <MessageReplyTo messageOrMessageGroup={replyMessage} />
      </div>
      <Button
        size="icon"
        variant="ghost"
        onClick={onClearReply}
        className="hover:bg-transparent"
        data-testid="clear-reply"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  )
}
